import React from "react"; // eslint-disable-line no-unused-vars
import styled from "styled-components";
import includes from "lodash/includes";
import { grayscale} from "polished";

import moment from "moment-timezone";
import "moment/locale/fr";
import Event from "./Event";
import Available from "./Available";
import CustomFree from "./CustomFree";
import Closed from "./Closed";
import CustomClosed from "./CustomClosed";

export const PAST = "past";
export const BOX = "box";
export const EVENT = "event";
export const CUSTOM_FREE = "customFree";
export const CUSTOM_CLOSED = "customClosed";
export const CUSTOM_UNAVAILABLE = "customUnavailable";
export const UNAVAILABLE = "unavailable";
export const AVAILABLE = "available";
export const CLOSED = "closed";

const SLOT_HEIGHT = 25;

export const Box = styled.div`
  background-color: #fff;
  color: #444;
  padding: 5px;
  display: flex;
  //  border-top: 1px solid #eee;
  border-right: 1px solid #fff;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: ${props => (props.time ? "0.9em" : "inherit")};
  border-top: ${props => (props.time ? "1px solid #eee" : "inherit")};
  &:nth-child(2) {
    border-top: ${props => (props.time ? "none" : "inherit")};
  }
`;
export const Header = Box.extend`
  background-color: #fff;
  border-bottom: ${props => (props.noBorder ? "none" : "2px solid #aaa")};
  border-right: none;//${props => (props.noBorder ? "none" : "1px solid #aaa")};
`;

export const Label = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const LabelLink = Label.extend`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const LabelEvent = styled.div`
word-wrap: break-word;
    /* line-height: 1; */
//    height: 100%;
    /* min-height: 100%; */
    width: 100%;
    line-height: 1;
    text-align: center;
}
`;

export const Unavailable = Box.extend`
  border-top: none;
/*  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAH0lEQVQYV2NkQAX/GZH4/xkYGBhhAmAOSBJEwDkgAQCCrgQEjpMcPgAAAABJRU5ErkJggg==)
    repeat;*/
  background-color: #c7ffde;
//  cursor: pointer;
border-top: 1px solid #fff;
border-right: 1px solid #fff;
  background-color: #caced1;
  border-color: #bcc2c6;

  &:hover {
    background-color: #aaa;
    color:#eee;
    &::before {
      content: "${props => props.time}";
    }
  }
`;
export const CustomUnavailable = Box.extend`
//border-top: none;
  /*background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAL0lEQVQYV2NkYGBgWLFixf+IiAjGFx4e/xmRORI7djAyglSAZEAckCRYGYwD0gYAu00dc5RrqiMAAAAASUVORK5CYII=)
    repeat;*/
  /*  background:url(
 data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAOklEQVQoU43MSwoAMAgD0eT+h7ZYaOlHo7N+DNHL2HAGgBWcyGcKbqTghTL4oQiG6IUpOqFEC5bI4QD8PAoKd9j4XwAAAABJRU5ErkJggg==
     ) repeat;*/
//  background-color: #7cb594;
//  background-color: #ccc;
//  cursor: pointer;

  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  background-color: ${grayscale("#62e79b")};//#caced1;
  border-color: ${grayscale("#2fdc16")};//#bcc2c6;

  &:hover {
    background-color: #aaa;
    color:#eee;
    &::before {
      content: "${props => props.time}";
    }
  }
`;
export const Past = Box.extend`
  border-top: none;
  border-right: none;
  /*  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAM0lEQVQoU2NkwAP+////nxGXPFgSBLApgEmC5DAUIEtiKECXRFGATRKuAJckWAE+SZACAIKGIAUwJOAdAAAAAElFTkSuQmCC)
    repeat;*/
  /*url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAIklEQVQYV2NkQAI9PT3/GWF8EKekpIQRLADjgNiMyByQAADHBQ6o45FCxgAAAABJRU5ErkJggg==)
    repeat;*/
  //  background-color: #ccc;
  background-color: transparent;
`;
/*
export const Closed = Box.extend`
  border-top: 1px solid ${lighten(0.08, "#ffabab")};//#fff; //#f19f9f;
  border-right: 1px solid ${lighten(0.08, "#ffabab")};

  background-color: #ffabab;
  cursor: pointer;
  &:hover {
    color:#eee;
    background-color: #f19f9f;
    &::before {
      content: "${props => props.time}";
    }
  }
`;
*/

/*export const AvailableContainer = Box.extend`
  border-top: 1px solid #90f4ba;
  border-right: 1px solid #90f4ba;
  height: 100%;
  cursor: pointer;

  background-color: #c7ffde;
  &:hover {
    background-color: #90f4ba;
    &::before {
      content: ${props => (props.time ? "skk" : "kkk")};
    }
  }
`;
export const AvailableContainerOver = Box.extend`
  border-top: 1px solid #90f4ba;
  height:100%

  background-color: blue;
`;*/

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.5);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export function getElement(slot, that, i) {
  let time = slot.date ? slot.date.format("HH:mm") : "";
  let key = i; //Math.random()
  //  .toString(36)
  //  .substr(2, 5);
  //  slot.type + slot.id + (slot.date !== null ? slot.date.valueOf() : "s");
  switch (slot.type) {
    case PAST:
      return <Past key={key} />;
    case BOX:
      return <Box key={key} />;
    case UNAVAILABLE:
      return (
        <Unavailable
          key={key}
          time={time}
          /*  onClick={() =>
            that.props.availableSlotClick(slot.type, slot.date, slot.slotTypes)}*/
        />
      );
    case CUSTOM_CLOSED:
      return (
        <CustomClosed
          key={key}
          time={time}
          date={slot.date}
          onClick={() =>
            that.props.availableSlotClick(
              slot.type,
              slot.date,
              slot.slotTypes,
              slot.id,
              slot.originalSlotTypes
            )}
        />
      );
    case CLOSED:
      return (
        <Closed
          key={key}
          time={time}
          date={slot.date}
          onClick={() =>
            that.props.availableSlotClick(slot.type, slot.date, slot.slotTypes)}
        />
      );
    case CUSTOM_FREE:
      return (
        <CustomFree
          key={key}
          time={time}
          date={slot.date}
          moveEvent={that.props.moveEvent}
          availableSlotClick={() =>
            that.props.availableSlotClick(
              slot.type,
              slot.date,
              slot.slotTypes,
              slot.id,
              slot.originalSlotTypes
            )}
        />
      );
    case CUSTOM_UNAVAILABLE:
      return (
        <CustomUnavailable
          key={key}
          time={time}
          /*  onClick={() =>
            that.props.availableSlotClick(slot.type, slot.date, slot.slotTypes)}*/
        />
      );
    case AVAILABLE:
      return (
        <Available
          key={key}
          time={time}
          date={slot.date}
          moveEvent={that.props.moveEvent}
          availableSlotClick={() =>
            that.props.availableSlotClick(
              slot.type,
              slot.date,
              slot.slotTypes,
              null,
              slot.originalSlotTypes
            )}
        />
      );
    case EVENT:
      return (
        <Event
          key={key}
          eventSlotClick={() => that.props.eventSlotClick(slot)}
          updateSelectedTypeId={that.props.updateSelectedTypeId}
          label={slot.label}
          color={slot.event.color}
          duration={slot.duration}
          id={slot.id}
          height={SLOT_HEIGHT}
          slotType={slot.event.slotType}
        />
      );
    default:
      return <Box key={key} />;
  }
}

export function setEvent(newDayColumns, eventStartTime, weekDay, slot) {
  let wd = newDayColumns[weekDay];

  wd.set(eventStartTime.format("HH:mm"), slot);
}

export function createSlot(
  type,
  label = "",
  id = "",
  date = null,
  slotTypes = [],
  duration,
  originalSlotTypes = null
) {
  return {
    type: type,
    label: label,
    id: id,
    date: date,
    slotTypes: slotTypes,
    duration: duration,
    originalSlotTypes: originalSlotTypes
  };
}
export function createEvent(event, view, baseDuration) {
  let caption = event.slotType.name;
  if (view === "day") {
    let patient = "Patient effacé";
    if (event.patient) {
      patient = `${event.patient.matricule} - ${event.patient.nom} ${event
        .patient.prenom}`;
    }
    if (event.comment && event.comment.length > 0) {
      caption = `${caption} - ${patient} : ${event.comment}`;
    } else {
      caption = `${caption} - ${patient}`;
    }
  }

  const modalEvent = {
    title: caption,
    start: event.startTime,
    createdAt: event.createdAt,
    end: moment(event.startTime)
      .clone()
      .add(event.slotType.duration * baseDuration, "minutes"),
    slotId: event.id,
    slotType: event.slotType,
    patient: event.patient,
    color: event.color === "none" ? "" : event.color,
    comment: event.comment,
    takenBy: event.takenBy
  };

  return {
    type: EVENT,
    label: caption,
    id: event.id,
    date: moment(event.startTime),
    event: modalEvent,
    duration: event.slotType.duration
  };
}

export function isAvailableForward(
  newDayColumns,
  eventStartTime,
  weekDay,
  props
) {
  if (props.selectedTypeDuration > 1) {
    let after = eventStartTime.clone();
    let max = after
      .clone()
      .hour(props.maxTimeAdmin)
      .minute(0);

    for (let i = 0; i < props.selectedTypeDuration - 1; i++) {
      if (after.isBefore(max, "minutes")) {
        after.add(props.baseDuration, "minutes");
        let currentSlot = newDayColumns[weekDay].get(after.format("HH:mm"));

        let slotTypesIds = currentSlot.slotTypes
          ? currentSlot.slotTypes.map(({ id }) => id)
          : null;
        if (
          props.selectedTypeId !== null &&
          !includes(slotTypesIds, props.selectedTypeId)
        ) {
          return false;
        }
      }
    }
  }
  return true;
}

export function renderUnavailable(
  newDayColumns,
  eventStartTime,
  weekDay,
  props
) {
  if (props.selectedTypeDuration > 1) {
    let before = eventStartTime.clone();
    let min = before
      .clone()
      .hour(props.minTimeAdmin)
      .minute(0);
    for (let i = 0; i < props.selectedTypeDuration - 1; i++) {
      if (
        before.isAfter(min, "minutes") &&
        before.isAfter(moment(), "minutes")
      ) {
        before.subtract(props.baseDuration, "minutes");
        let currentSlot = newDayColumns[weekDay].get(before.format("HH:mm"));
        if (currentSlot.type === AVAILABLE) {
          setEvent(
            newDayColumns,
            before,
            weekDay,
            createSlot(
              UNAVAILABLE,
              "",
              "",
              currentSlot.date.clone(),
              currentSlot.slotTypes
            )
          );
        }
        if (currentSlot.type === CUSTOM_FREE) {
          setEvent(
            newDayColumns,
            before,
            weekDay,
            createSlot(
              CUSTOM_UNAVAILABLE,
              currentSlot.id,
              "",
              currentSlot.date.clone(),
              currentSlot.slotTypes
            )
          );
        }
      }
    }
    //
  }
}

export function renderTimeColumn(that) {
  return that.state.timeColumn.map((time, i) => {
    if (time.length > 0) {
      return (
        <Box key={i + time} time>
          {time}
        </Box>
      );
    } else {
      return <Header key={i + time} noBorder />;
    }
  });
}

export function generateColumn(
  day,
  dayTemplate,
  timeColumn,
  selectedTypeId,
  selectedTypeDuration
) {
  day.locale("fr");
  let title = day.format("ddd DD");
  let column = new Map();
  column.set("title", { title, day });

  for (let i = 1; i < timeColumn.length; i++) {
    let time = timeColumn[i].split(":");
    let currentDate = day.hour(time[0]).minute(time[1]);
    if (dayTemplate === null) {
      column.set(timeColumn[i], createSlot(BOX, "", "", null));
    } else if (dayTemplate.length === 0) {
      column.set(
        timeColumn[i],
        createSlot(CLOSED, "", "", currentDate.clone())
      );
    } else if (currentDate.isBefore(moment(), "minutes")) {
      column.set(timeColumn[i], createSlot(PAST, "", "", null));
    } else {
      //hour.time has format : 9:00
      let timeMatch = dayTemplate.hours.find(
        hour => hour.time === currentDate.format("H:mm")
      );

      if (!timeMatch || timeMatch.slotTypes.length === 0) {
        column.set(
          timeColumn[i],
          createSlot(CLOSED, "", "", currentDate.clone())
        );

        if (selectedTypeDuration > 1) {
          for (let k = 1; k < selectedTypeDuration; k++) {
            if (i - k > -1) {
              let previousSlot = column.get(timeColumn[i - k]);
              if (
                previousSlot &&
                (previousSlot.type === AVAILABLE ||
                  previousSlot.type === CUSTOM_FREE)
              )
                column.set(
                  timeColumn[i - k],
                  createSlot(
                    UNAVAILABLE,
                    "",
                    "",
                    previousSlot.date.clone(),
                    previousSlot.slotTypes
                  )
                );
            }
          }
        }
      } else {
        let slotTypesIds = timeMatch.slotTypes.map(({ id }) => id);
        if (
          selectedTypeId !== null &&
          !includes(slotTypesIds, selectedTypeId)
        ) {
          column.set(
            timeColumn[i],
            createSlot(CLOSED, "", "", currentDate.clone(), timeMatch.slotTypes)
          );
          if (selectedTypeDuration > 1) {
            for (let k = 1; k < selectedTypeDuration; k++) {
              if (i - k > -1) {
                let previousSlot = column.get(timeColumn[i - k]);
                if (
                  previousSlot &&
                  (previousSlot.type === AVAILABLE ||
                    previousSlot.type === CUSTOM_FREE)
                )
                  column.set(
                    timeColumn[i - k],
                    createSlot(
                      UNAVAILABLE,
                      "",
                      "",
                      previousSlot.date.clone(),
                      previousSlot.slotTypes
                    )
                  );
              }
            }
          }
        } else {
          column.set(
            timeColumn[i],
            createSlot(
              AVAILABLE,
              "",
              "",
              currentDate.clone(),
              timeMatch.slotTypes,
              null,
              timeMatch.slotTypes
            )
          );
        }
      }
    }
  }
  return column;
}
export function generateTimeColumn(
  date,
  baseDuration,
  minTimeAdmin,
  maxTimeAdmin
) {
  let timeColumn = [""];
  let start = date.clone();
  let finish = date.clone();
  start.hour(minTimeAdmin);
  start.minute(0);
  start.second(0);
  start.millisecond(0);
  finish.hour(maxTimeAdmin);
  finish.minute(0);
  finish.second(0);
  finish.millisecond(0);
  while (start.isBefore(finish, "minutes")) {
    timeColumn.push(start.format("HH:mm"));
    start.add(baseDuration, "minutes");
  }
  return timeColumn;
}

export function generateDay(
  day,
  timeColumn,
  week,
  specialDays,
  selectedTypeId,
  selectedTypeDuration
) {
  let weekDayName = day.format("dddd").toLowerCase();
  let dayTemplate = null;
  if (week !== null) {
    //specialDay
    let specialDay = specialDays.find(d => {
      if (d.endDate !== null) {
        return day.isBetween(moment(d.date), moment(d.endDate), "day", "[]");
      }
      return moment(d.date).isSame(day, "day");
    });
    /*props.specialDays.find(d =>
      moment(d.date).isSame(day, "day")
    );*/
    if (!specialDay) {
      dayTemplate = week.days.find(d => d.day === weekDayName);
      if (dayTemplate.dayTemplate === null) {
        dayTemplate = [];
      } else {
        dayTemplate = dayTemplate.dayTemplate;
      }
    } else {
      dayTemplate = specialDay.dayTemplate;
    }
  }
  return generateColumn(
    day,
    dayTemplate, //? dayTemplate.dayTemplate : dayTemplate,
    timeColumn,
    selectedTypeId,
    selectedTypeDuration
  );
}
export function generateWeek(timeColumn, props) {
  let now = props.date.clone();
  let weekStart = now.startOf("week");
  //var weekEnd = currentDate.clone().endOf("week");
  let nbrDays = 7;
  if (props.view === "day") {
    nbrDays = 1;
    weekStart = props.date;
  }
  let daysColumns = [];
  for (let i = 0; i < nbrDays; i++) {
    let day = moment(weekStart).add(i, "days");
    day.locale("en");
    daysColumns.push(
      generateDay(
        day,
        timeColumn,
        props.week,
        props.specialDays,
        props.selectedTypeId,
        props.selectedTypeDuration
      )
    );
  }
  return daysColumns;
}

export function renderWeek(that) {
  let toRender = [];
  that.state.dayColumns.forEach((day, i) => {
    day.forEach((value, key) => {
      let k = value.title + key + "w";

      if (key === "title") {
        if (that.props.view === "week") {
          let date = value.day;
          toRender.push(
            <Header key={k}>
              <LabelLink onClick={() => that.props.handleNavigate(date)}>
                {value.title}
              </LabelLink>
            </Header>
          );
        } else {
          toRender.push(
            <Header key={k}>
              <Label>{value.title}</Label>
            </Header>
          );
        }
      } else {
        toRender.push(getElement(value, that, i + key));
      }
    });
  });
  return toRender;
}

export function addEvents(newDayColumns, events, props, draggingEventId) {
  events.forEach(event => {
    let weekDay = 0;
    if (props.view === "week") {
      weekDay = moment(event.startTime).weekday();
    }
    if (draggingEventId == null || event.id !== draggingEventId) {
      setEvent(
        newDayColumns,
        moment(event.startTime),
        weekDay,
        createEvent(event, props.view, props.baseDuration)
      );
      renderUnavailable(newDayColumns, moment(event.startTime), weekDay, props);
    } else {
      setEvent(
        newDayColumns,
        moment(event.startTime),
        weekDay,
        createEvent(event, props.view, props.baseDuration)
      );
    }
  });
}
export function addCustomEvents(newDayColumns, customSlots, props) {
  customSlots.forEach(event => {
    let weekDay = 0;
    if (props.view === "week") {
      weekDay = moment(event.startTime).weekday();
    }
    let cslotTypesIds = event.slotTypes.map(({ id }) => id);
    let originalSlot = newDayColumns[weekDay].get(
      moment(event.startTime).format("HH:mm")
    );
    if (originalSlot) {
      let originalSlotTypes = originalSlot.slotTypes;
      if (
        originalSlot.type === EVENT ||
        moment(event.startTime).isBefore(moment())
      ) {
        return;
      } else if (
        event.slotTypes &&
        event.slotTypes.length > 0 &&
        (props.selectedTypeId === null ||
          includes(cslotTypesIds, props.selectedTypeId))
      ) {
        setEvent(
          newDayColumns,
          moment(event.startTime),
          weekDay,
          createSlot(
            CUSTOM_FREE,
            "",
            event.id,
            moment(event.startTime),
            event.slotTypes,
            null,
            originalSlotTypes
          )
        );
        let isAvailable = true;
        if (props.selectedTypeId === null) {
          isAvailable = true;
        } else {
          isAvailable = isAvailableForward(
            newDayColumns,
            moment(event.startTime),
            weekDay,
            props
          );
        }
        if (isAvailable) {
          setEvent(
            newDayColumns,
            moment(event.startTime),
            weekDay,
            createSlot(
              CUSTOM_FREE,
              "",
              event.id,
              moment(event.startTime),
              event.slotTypes,
              null,
              originalSlotTypes
            )
          );
        } else {
          setEvent(
            newDayColumns,
            moment(event.startTime),
            weekDay,
            createSlot(
              CUSTOM_UNAVAILABLE,
              "",
              event.id,
              moment(event.startTime),
              event.slotTypes
            )
          );
          /*    (
          "ddlfkdlkfldklkd",
          CUSTOM_UNAVAILABLE,
          moment(event.startTime).format("HH:mm")
        );*/
          /*  renderUnavailable(
          newDayColumns,
          moment(event.startTime),
          weekDay,
          props
        );*/
        }
      } else {
        setEvent(
          newDayColumns,
          moment(event.startTime),
          weekDay,
          createSlot(
            CUSTOM_CLOSED,
            "",
            event.id,
            moment(event.startTime),
            [],
            null,
            originalSlotTypes
          )
        );
        renderUnavailable(
          newDayColumns,
          moment(event.startTime),
          weekDay,
          props
        );
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/components/utilities/calendar/calendar-utils.js